import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const ARROW_FOCUS_TRAP_ITEM_ACTIONS_CLASS_NAME =
	'ArrowFocusTrapItemActions';
export const ARROW_FOCUS_TRAP_ITEM_ACTIONS_CLASS_SLOTS = ['root'] as const;

export type ArrowFocusTrapItemActionsClassSlot =
	(typeof ARROW_FOCUS_TRAP_ITEM_ACTIONS_CLASS_SLOTS)[number];

export interface ArrowFocusTrapItemActionsClasses {
	root: string;
}

export type ArrowFocusTrapItemActionsClassKey =
	keyof ArrowFocusTrapItemActionsClasses;

export const getArrowFocusTrapItemActionsUtilityClass = (slot: string) =>
	generateUtilityClass(ARROW_FOCUS_TRAP_ITEM_ACTIONS_CLASS_NAME, slot);

export const arrowFocusTrapItemActionsClasses: ArrowFocusTrapItemActionsClasses =
	generateUtilityClasses(ARROW_FOCUS_TRAP_ITEM_ACTIONS_CLASS_NAME, ['root']);

export default arrowFocusTrapItemActionsClasses;
